
  import {Component, Vue} from "vue-property-decorator";
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import {IApp} from "@/interfaces/app.interface";
  import BarrierButton from "@/modules/barriers/components/BarrierButton.vue";
  import BalanceMenuButton from "@/modules/Payment/components/BalanceMenuButton.vue";
  import AntiTheftBtn from "@/modules/CarList/components/AntiTheftComponents/AntiTheftBtn.vue";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({
    components: {
      BarrierButton,
      BalanceMenuButton,
      AntiTheftBtn,
    },
  })
  export default class MobileNavigation extends Vue {
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    pages = IApp.ROUTE_NAME;

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get isUser() { return this.$store.state.auth.isUser; }
    get anonymous() { return this.$store.state.route.query[ANONYMOUS_PAGE] ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE]) : false; }
    get refMode() { return this.$store.state.profile.refMode; }

    async openPage(page: IApp.ROUTE_NAME) {
      await this.$store.dispatch('openPage', {routeName: page});
    }
  }
